module.exports = __webpack_public_path__ + "static/img/jxsLogo.a04a9aa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/jxsLogo.png
// module id = Icar
// module chunks = 113